/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import { uniqBy } from 'lodash-es';
import {
  getActivitiesfromGrids,
  getAllActivities as _getAllActivities,
} from '@/services/api/activity/coveredActivity';

import { findBy } from '@/utils/activities';

// initial state
const state = {
  activities: [],
  researchResult: [],
};

// getters
const getters = {
  activities: (state) => state.allActivities,
  researchResult: (state) => state.researchResult,
};

// actions
const actions = {
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  /**
   ** Retrieve list of all activities
   */
  async getAllActivities({ commit, dispatch }) {
    try {
      const { data } = await _getAllActivities();
      const activities = data.filter(({ enabled }) => enabled);
      commit('SET_VALUE', { activities });
    } catch (err) {
      dispatch('reporting/sendError', { err, currentPage: 'Activity' }, { root: true });
    }
  },
  /**
   * Research a term in all activities
   * @param {String} term value to be researched in all activities list
   * @returns {Array{Object}} activities found in list
   */
  search({ state, commit }, { value }) {
    const keys = [{ name: 'name', weight: 1 }];
    const list = uniqBy(state.activities, 'id');
    const researchResult = findBy(value, list, keys)
      .map(({ item }) => item);
    commit('SET_VALUE', { researchResult });
  },
  async setCustomListMrp({ commit, rootGetters }) {
    const rc = rootGetters['rater/products']
      .find(({ id }) => id === 1);
    const mrp = rootGetters['rater/products']
      .find(({ id }) => id === 16);

    if (rc && mrp) {
      const grids = [...rc.grids, ...mrp.grids];
      const { data } = await getActivitiesfromGrids(grids);
      const activities = data.filter(({ enabled }) => enabled);
      commit('SET_VALUE', { activities });
    }
  },
  async setCustomList({ commit }, gridId) {
    const { data } = await getActivitiesfromGrids([gridId]);
    const activities = data.filter(({ enabled }) => enabled);
    commit('SET_VALUE', { activities });
    return Promise.resolve();
  },
};

const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    Object.assign(state, { [key]: object[key] });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
